const apis = [
    { apiName: 'refresh-token', method: 'post', url: 'api/v1/auth-center-service/auth/refresh-token' },//刷新token

    { apiName: 'get-manage-merchants', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/get-manage-merchants' },//获取（管理员）所管理的商户列表
    { apiName: 'change-merchant', method: 'put', url: 'api/v1/merchant-center-service/auth/merchant/change-merchant' },//切换商户


    { apiName: 'sum-order-amount-by-merchant', method: 'get', url: 'api/v1/order-center-service/order/sum-order-amount-by-merchant' },//获取后台首页销售总金额
    { apiName: 'sum-product-by-merchant', method: 'get', url: 'api/v1/product-center-service/product/sum-product-by-merchant' },//获取商品总数和分类总数




    { apiName: 'get-wx-auth-config', method: 'get', url: 'api/v1/auth-center-service/auth/web-auth/get-wx-auth-config' },//获取微信授权登陆信息
    { apiName: 'get-wx-auth-url', method: 'get', url: 'api/v1/auth-center-service/auth/web-auth/get-wx-auth-url' },//获取微信授权登录URL二维码地址

    { apiName: 'login', method: 'post', url: '/api/login' },//登录接口
    { apiName: 'get-specs', method: 'get', url: 'api/v1/product-center-service/spec/get-specs' },//get-specs获取商品规格列表
    { apiName: 'add-specs', method: 'post', url: 'api/v1/product-center-service/auth/spec/add' },//添加商品规格
    { apiName: 'del-specs', method: 'delete', url: 'api/v1/product-center-service/auth/spec/del-specs' },//删除商品规格
    { apiName: 'update-spec', method: 'put', url: 'api/v1/product-center-service/auth/spec/update' },//修改商品规格


    { apiName: 'add-product', method: 'post', url: 'api/v1/product-center-service/auth/product/add' },//添加商品
    { apiName: 'get-products', method: 'get', url: 'api/v1/product-center-service/product/get-products' },//商品列表
    { apiName: 'update-product', method: 'put', url: 'api/v1/product-center-service/auth/product/update' },//编辑商品
    { apiName: 'del-products', method: 'delete', url: 'api/v1/product-center-service/auth/product/del-products' },//删除商品
    { apiName: 'get-product-info', method: 'get', url: 'api/v1/product-center-service/product/get-product-info' },//获取商品详情


    { apiName: 'add-cate', method: 'post', url: 'api/v1/product-center-service/auth/cate/add' },//添加商品分类
    { apiName: 'get-cates', method: 'get', url: 'api/v1/product-center-service/cate/get-cates' },//获取商品分类
    { apiName: 'del-cates', method: 'delete', url: 'api/v1/product-center-service/auth/cate/del-cates' },//删除商品分类
    { apiName: 'update-cates', method: 'put', url: 'api/v1/product-center-service/auth/cate/update' },//删除商品分类


    { apiName: 'get-commune-list', method: 'get', url: '/api/v1/commune-center-service/commune/get-commune-list' },//我的圈子
    { apiName: 'add-merchant', method: 'post', url: 'api/v1/merchant-center-service/auth/merchant/add-merchant' },//注册商户
    { apiName: 'get-current-merchant', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/get-current-merchant' },//获取商户信息


    { apiName: 'get-user-fans', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/get-user-fans' },//我的粉丝
    { apiName: 'forbidden-fans', method: 'put', url: 'api/v1/merchant-center-service/auth/merchant/forbidden-fans' },//屏蔽用户
    { apiName: 'get-merchant-fans', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/get-merchant-fans' },//我的商户
    { apiName: 'get-forbidden-user-fans', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/get-forbidden-user-fans' },//屏蔽的用户
    { apiName: 'get-forbidden-merchant-fans', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/get-forbidden-merchant-fans' },//屏蔽的商户
    { apiName: 'un-forbidden-fans', method: 'put', url: 'api/v1/merchant-center-service/auth/merchant/un-forbidden-fans' },//取消屏蔽


    { apiName: 'get-channels', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/get-channels' },//渠道列表
    { apiName: 'add-channels', method: 'post', url: 'api/v1/merchant-center-service/auth/merchant/add-channel' },//添加列表
    { apiName: 'del-channels', method: 'delete', url: 'api/v1/merchant-center-service/auth/merchant/del-channels' },//删除列表
    { apiName: 'update-channel', method: 'put', url: 'api/v1/merchant-center-service/auth/merchant/update-channel' },//修改渠道
    { apiName: 'get-members', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/channel/get-members' },//获取渠道成员
    { apiName: 'gb-list', method: 'get', url: 'api/v1/gb-center-service/auth/group-buying/merchant-gb-stat-list' },//团购列表
    { apiName: 'gb-info', method: 'get', url: 'api/v1/gb-center-service/group-buying/gb-info' },//团购详情
    { apiName: 'contract-info', method: 'get', url: 'api/v1/gb-center-service/group-buying/contract-info' },//获取合约详情





    { apiName: 'gb-stat', method: 'get', url: 'api/v1/gb-center-service/auth/group-buying/gb-stat' },//团购销售统计
    { apiName: 'verify-gb-list', method: 'get', url: 'api/v1/gb-center-service/auth/group-buying/verify-gb-list' },//团购审核列表
    { apiName: 'pause-gb', method: 'put', url: 'api/v1/gb-center-service/auth/group-buying/pause-gb' },//暂停团购
    { apiName: 'resume-gb', method: 'put', url: 'api/v1/gb-center-service/auth/group-buying/resume-gb' },//取消暂停团购
    { apiName: 'gb-products', method: 'get', url: 'api/v1/gb-center-service/group-buying/gb-products' },//获取团购商品列表
    { apiName: 'contract-products', method: 'get', url: 'api/v1/gb-center-service/group-buying/contract-products' },//获取合约商品列表
    { apiName: 'gb-update', method: 'put', url: 'api/v1/gb-center-service/auth/group-buying/gb-update' },//修改团购
    { apiName: 'update-gb-products-stock', method: 'get', url: 'api/v1/product-center-service/product/update-gb-products-stock' },//汇总单修改团购商品库存
    //{ apiName: 'product-center-service', method: 'post', url: 'api/v1/order-center-service/product/product-center-service' },//汇总单修改团购商品库存





    { apiName: 'get-orders', method: 'get', url: 'api/v1/order-center-service/order/get-orders' },//订单列表

    { apiName: 'get-order-after-service-logs-for-back', method: 'get', url: 'api/v1/order-center-service/order/get-order-after-service-logs-for-back' },//获取订单售后协商记录（后台使用）

    { apiName: 'handle-order-after-service', method: 'post', url: 'api/v1/order-center-service/order/handle-order-after-service' },//处理售后

    { apiName: 'get-order', method: 'get', url: 'api/v1/order-center-service/order/get-order' },//订单详情
    { apiName: 'add-orders-export', method: 'post', url: 'api/v1/order-center-service/order/add-orders-export' },//添加导出订单
    { apiName: 'get-orders-exports', method: 'get', url: 'api/v1/order-center-service/order/get-orders-exports' },//获取导出订单任务
    { apiName: 'get-task-list', method: 'get', url: 'api/v1/order-center-service/order/get-task-list' },//获取定时任务列表
    { apiName: 'get-delivery-list', method: 'get', url: 'api/v1/order-center-service/order/get-delivery-list' },//获取配送单列表-定时任务
    { apiName: 'add-task', method: 'post', url: 'api/v1/order-center-service/order/add-task' },//创建定时任务
    { apiName: 'switch-task', method: 'put', url: 'api/v1/order-center-service/order/switch-task' },//开关定时任务
    { apiName: 'delete-task', method: 'delete', url: 'api/v1/order-center-service/order/delete-task' },//删除定时任务


    { apiName: 'get-order-after-services', method: 'get', url: 'api/v1/order-center-service/order/get-order-after-services' },//售后管理列表
    { apiName: 'add-order-remark', method: 'post', url: 'api/v1/order-center-service/order/add-order-remark' },//添加订单备注



    { apiName: 'wx-merchant-query', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/account/sub-mch/applyment/query' },//微信商户进件状态查询
    { apiName: 'wx-merchant-apply', method: 'post', url: 'api/v1/merchant-center-service/auth/merchant/account/sub-mch/apply' },//微信商户进件
    { apiName: 'balance-record', method: 'get', url: 'api/v1/user-center-service/auth/merchant/balance-record' },//账户资产明细
    { apiName: 'balance-info', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/account/balance-info' },//获取商户账户信息
    { apiName: 'get-balance-records', method: 'get', url: 'api/v1/merchant-center-service/auth/merchant/account/get-balance-records' },//账户资产明细列表
    { apiName: 'balance-records', method: 'get', url: 'api/v1/user-center-service/auth/merchant/balance-records' },//账户资产明细

    {apiName: 'add-order-export-once-task', method: 'post', url: 'api/v1/task-center-service/auth/add/order-export-once-task'},
];

export default  apis;